import React from 'react'
import Heading from '../../../common/Heading'
import { team } from '../../data/data'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlaceIcon from '@mui/icons-material/Place';
import './team.css'
import ChatIcon from '@mui/icons-material/Chat';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Team = () => {
    return (
        <section className="team background">
            <div className="container">
                <Heading title='Our Featured Agents
                ' subtitle='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.' />

                <div className="content mtop grid3">
                    {team.map((val, index) => {
                        return (
                            <div className="box" key={index}>
                                <button className='btn3' > {val.list} Listing</button>
                                <div className="details">
                                    <div className="img">
                                        <img src={val.cover} alt="" />
                                        <CheckCircleIcon className='i' />
                                    </div>
                                    <div className="loc">
                                        <PlaceIcon className='i' />
                                        <label htmlFor="">{val.address}</label></div>
                                    <h4>{val.name}</h4>

                                    <ul className='media'>
                                        <li><WhatsAppIcon/></li>
                                        {/* <li><FacebookIcon/></li>
                                        <li><TwitterIcon/></li> */}
                                        <li><LinkedInIcon/></li>
                                        <li><InstagramIcon/></li>
                                    </ul>
                                    <div className="button flex">
                                        <button>
                                            <div className="i"> <ChatIcon/> Message</div>
                                        </button>
                                        <button className="btn4">
                                            <div className="i"><LocalPhoneIcon/></div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default Team
